export default "__VITE_ASSET__CvV6U0w4__"